export default __webpack_public_path__ + "static/media/hht1_ep17_timeline_q04_b.cff77885.png";